import {
  React,
  Heading,
  Subtitle,
  Text,
  Divider,
  Button,
  Row, 
  Col
} from "mondrian-react";
import { handleMesMask } from "utils/handleMesMask";
import { logger } from "utils/logger";
import useIsTotem from "hooks/useIsTotem";
import Barcode from "react-barcode";
import { stepBar } from "./variables";
import { isMobile } from "react-device-detect";
import Banks from "components/Banks";

//CSS
import "./styles.scss";
import { reportGA4 } from "utils/pushDataLayer";

const PaymentCodeBar = ({ fatura, goBack, setCodeBarAlert }) => {
  const splittedDate = fatura.paymentDueDate.split("-");
  const formattedDate = `${splittedDate[2]}/${splittedDate[1]}/${splittedDate[0]}`;
  const formattedLabelDate = `${handleMesMask(splittedDate[1])} • ${
    splittedDate[0]
  }`;
  const billCodetoBar = (fatura.billCode.length === 48) ? fatura.billCode.slice(0, 11)+fatura.billCode.slice(12, 23)+fatura.billCode.slice(24, 35)+fatura.billCode.slice(36, 47) : fatura.billCode;
  const propsBarCode = {
    width: 1.4,
    height: 60,
    format: "ITF",
    displayValue: false,
    fontOptions: "",
    font: "monospace",
    textAlign: "center",
    textPosition: "bottom",
    textMargin: 2,
    fontSize: 20,
    background: "transparent",
    lineColor: "#000000",
    value: billCodetoBar,
  };

  const isTotem = useIsTotem();

  return (
    <>
      <Row>
        <Col xs={12} lg={10} className="mdn-Offset-lg-2">
          <Subtitle xs className="textTitular">
            {formattedLabelDate}
          </Subtitle>
        </Col>
      </Row>
      <Row>
        <Col xs={12} lg={7} className="mdn-Offset-lg-2 mdn-u-flex mdn-u-flex-xs-column mdn-u-flex-lg-row mdn-u-justifyContent-lg-between mdn-u-alignItems-lg-center">
            <Heading xl className="textMoney">
            R$ {parseFloat(fatura.billAmount).toFixed(2).replace(".", ",")}
            </Heading>
            <Text body className="textDue">
              Vencimento: {formattedDate}
            </Text>
            <div className="mdn-Tag mdn-Tag-category mdn-Tag--feedback mdn-u-marginTop--xxs mdn-u-marginBottom--xxs">
              <i className="mdn-Tag-icon mdn-Icon-alerta mdn-Icon--sm"></i>
              <p className="mdn-Text textAberto">Aberto</p>
            </div>
        </Col>
      </Row>      
      <Row>
        <Col xs={12} lg={8} className="mdn-Offset-lg-2">    
          <Heading lg className="textTitle mdn-u-marginBottom--sm">
            Código de barras
          </Heading>  
          <div className="divBar">
            <p className="mdn-CopyContainer-content-toCopy mdn-Heading mdn-Heading--xxs mdn-u-marginTop--sm">
              {fatura.billCode}
            </p>
            <Divider className="codeBarDivider" />
            {!isMobile && <Barcode {...propsBarCode} />}
            {!isTotem &&
              <Button
                className="copyCodeBarButton"
                onClick={() => {
                  logger({ name: "CopyBarCodeButton" });
                  reportGA4({customTitle: 'codigo_de_barras:copiar_codigo_de_barras'})
                  navigator.clipboard.writeText(fatura.billCode);
                  setCodeBarAlert(true);
                }}
              >
                Copiar código de barras
              </Button>
            }
          </div>
          <Heading xs className="textTitular">
            Siga essas instruções para o pagamento
          </Heading>
          {stepBar.map((o, i) => (
            <div
              key={i.toString() + o.step}
              className="mdn-Topic mdn-Topic--horizontal mdn-Topic--number mcm-Circle"
            >
              <div>
                <p className="mdn-Topic-description stepTextCircle">{o.step}</p>
              </div>
              <p className="mdn-Topic-description mcm-TitleGray">{o.text}</p>
            </div>
          ))}
          <div className="mdn-Tag mdn-Tag--feedback mdn-Tag--inverse alertText">
            <i className="mdn-Tag-icon mdn-Icon-alerta mdn-Icon--sm alertColor"></i>
            <p className="alertColor">
              Atenção! A forma de pagamento selecionada valerá para um único
              pagamento e não será recorrente para as outras faturas ou transações.
            </p>
          </div>
          {!isTotem &&
            <div>
              <Banks localTag="codigo_de_barras" />
              <div className="mdn-Tag mdn-Tag--feedback mdn-Tag--inverse divInfo">
                <i className="mdn-Tag-icon mdn-Icon-alerta mdn-Icon--sm alertColor"></i>
                <p className="alertColor">
                  O seu pagamento pode ser confirmado em 5h se for feito através dos
                  bancos conveniados (Itaú, Santander, Bradesco, Caixa e Safra). Para os
                  demais bancos a confirmação será feita em até 3 dias. Lembre-se de
                  pagar seu boleto até a data de vencimento original de sua fatura para
                  evitar juros e multa.
                </p>
              </div>
            </div>
          }
        </Col>
      </Row>
      <Row>
        <Col xs={12} className="mdn-u-marginTop--lg mdn-u-marginBottom--lg">
          <Button secondary href={"#"} onClick={() => {
            goBack()
            reportGA4({customTitle: 'codigo_de_barras:voltar'})
          }}>Voltar</Button>
        </Col>
      </Row>
    </>
  );
};

export default PaymentCodeBar;
